export default function StarShrinkIco() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1155 9.71492C11.1536 9.79203 11.2157 9.8547 11.2925 9.89353L13.5203 11.0203C13.8111 11.1674 13.8111 11.5826 13.5203 11.7297L11.2925 12.8565C11.2157 12.8953 11.1536 12.958 11.1155 13.0351L10.0066 15.2789C9.86074 15.5741 9.43976 15.5741 9.29387 15.2789L8.18496 13.0351C8.14685 12.958 8.08476 12.8953 8.008 12.8565L5.7802 11.7297C5.48938 11.5826 5.48938 11.1674 5.7802 11.0203L8.008 9.89353C8.08476 9.8547 8.14685 9.79203 8.18496 9.71492L9.29388 7.4711C9.43976 7.17591 9.86074 7.17591 10.0066 7.4711L11.1155 9.71492Z"
        fill="#FA4F96"
      />
      <path
        d="M5.6137 4.38113C5.65134 4.45845 5.71304 4.52148 5.78954 4.56077L6.92998 5.14638C7.2179 5.29422 7.2179 5.70578 6.92998 5.85362L5.78954 6.43923C5.71304 6.47852 5.65134 6.54155 5.6137 6.61887L5.05544 7.76573C4.91036 8.06377 4.48567 8.06377 4.34059 7.76573L3.78234 6.61887C3.7447 6.54155 3.683 6.47852 3.60649 6.43923L2.46605 5.85362C2.17813 5.70578 2.17813 5.29422 2.46605 5.14638L3.60649 4.56077C3.683 4.52148 3.7447 4.45845 3.78234 4.38113L4.34059 3.23427C4.48568 2.93623 4.91036 2.93623 5.05544 3.23427L5.6137 4.38113Z"
        fill="#FA4F96"
      />
      <path
        d="M10.3554 1.46418C10.3927 1.54166 10.454 1.60495 10.5303 1.64458L11.2574 2.02223C11.5431 2.17064 11.5431 2.57936 11.2574 2.72777L10.5303 3.10542C10.454 3.14505 10.3927 3.20835 10.3554 3.28582L10.009 4.0056C9.86456 4.30581 9.43706 4.30581 9.2926 4.0056L8.94624 3.28582C8.90896 3.20835 8.84757 3.14505 8.77127 3.10542L8.04423 2.72777C7.75853 2.57936 7.75853 2.17064 8.04423 2.02223L8.77127 1.64458C8.84757 1.60495 8.90896 1.54166 8.94624 1.46418L9.2926 0.744396C9.43706 0.444195 9.86456 0.444195 10.009 0.744396L10.3554 1.46418Z"
        fill="#FA4F96"
      />
    </svg>
  );
}
